import { safeShaderReplace, type ShaderProgramLike } from "../shaderUtils";

const ensureSetWorldPosVertex = `
#if (!defined(USE_ENVMAP) || !defined(ENV_WORLDPOS)) && !defined(USE_TRANSMISSION) && !defined(HIGHARC_WORLDPOS_SET)
#define HIGHARC_WORLDPOS_SET
vWorldPosition = worldPosition;
#endif
`;

const defineWorldPosVarying = `
#if (!defined(USE_ENVMAP) || !defined(ENV_WORLDPOS)) && !defined(USE_TRANSMISSION) && !defined(HIGHARC_WORLDPOS_DEFINED)
#define HIGHARC_WORLDPOS_DEFINED
varying vec4 vWorldPosition;
#endif
`;

/**
 * Will make sure that vWorldPosition is defined in the fragment shader.
 * @param shader
 */
export function ensureWorldPositionInFragShader(shader: ShaderProgramLike) {
  if (!shader.vertexShader.includes("HIGHARC_WORLDPOS_SET")) {
    shader.vertexShader = safeShaderReplace(
      shader.vertexShader,
      "#include <worldpos_vertex>",
      `#include <worldpos_vertex>
        ${ensureSetWorldPosVertex}`,
      "ensureWorldPositionInFragShader vertex shader (worldpos_vertex)",
    );
    shader.vertexShader = safeShaderReplace(
      shader.vertexShader,
      "#include <common>",
      `#include <common>
      ${defineWorldPosVarying}
      `,
      "ensureWorldPositionInFragShader vertex shader (common)",
    );
    shader.fragmentShader = safeShaderReplace(
      shader.fragmentShader,
      "#include <common>",
      `#include <common>
      ${defineWorldPosVarying}
      `,
      "ensureWorldPositionInFragShader fragment shader (common)",
    );
  }
}
